import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import {
  isScopedMessagesQueryKey,
  messagesApiQueryKeys,
} from '@/features/dashboard/messages/api/messagesApi.queryKeys.ts';
import messagesApi from '@/features/dashboard/messages/api/messagesApi.ts';

const useCancelMessage = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (id) => messagesApi.cancelMessage(id),
    onSuccess: () => {
      toast.success('Wiadomość została anulowana');
      queryClient.invalidateQueries({
        queryKey: messagesApiQueryKeys.all(),
      });
      queryClient.invalidateQueries({
        predicate: (query) => isScopedMessagesQueryKey(query.queryKey),
      });
    },
    onError: (error: Error) => {
      toast.error('Nie udało się anulować wiadomości', {
        description: error.message,
      });
    },
  });
};

export default useCancelMessage;
